module.exports = __webpack_public_path__ + "assets/mobile_back_white-e1ea6f.svg";